import $ from "jquery";
import request from "~/request";

$(document).on("turbolinks:load", () => {
  $("[data-role='mark-report-viewed']").on("click", (e) => {
    $(e.target).closest(".transfer-notification").slideUp();
    request.markTransferViewed($(e.target).closest("[data-role='mark-report-viewed']").data("transferId"));
  });
});
